var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 129,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 830.5,
    cy: 585.5,
    r: 64,
    fill: "none",
    stroke: "#FFF",
    transform: "translate(-766 -521)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternCircle);
export default __webpack_public_path__ + "static/media/pattern-circle.0e9ea7e2d6255d388d672d05bb9cfb04.svg";
export { ForwardRef as ReactComponent };